import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import img1 from "./img/cardMenuImg1.png";
import img2 from "./img/cardMenuImg2.png";
import img3 from "./img/cardMenuImg3.png";
import img4 from "./img/cardMenuImg4.png";

// Card Data
const cardData = [
  {
    gridSize: 7,
    image: img1,
    title: "Turn Leads into Customers Effortlessly",
    description:
      "Let your chatbot do the heavy lifting by qualifying leads easily, driving conversions without human intervention.",
  },
  {
    gridSize: 5,
    image: img2,
    title: "A Chatbot Builder for Non-techies",
    description:
      "Build multiple WhatsApp Chatbots easily, thanks to a drag-and-drop interface that requires zero coding expertise.",
  },
  {
    gridSize: 5,
    image: img3,
    title: "24x7 Support & Sales Automation on WhatsApp",
    description:
      "Automate Support & Sales processes with dynamic Chatbots answering your customer's common queries, helping them arrive at the sales decision 3x faster!",
  },
  {
    gridSize: 7,
    image: img4,
    title: "Seamless Integration with Business Tools",
    description:
      "Connect your Chatbot with WhatsApp Catalogues & WhatsApp Pay to showcase your Catalogues & drive payments directly within WhatsApp.",
  },
];

// Background colors
const backgroundColors = ["#ffeee6", "#f3e6ff", "#c8e4f5", "#e6f4ea"];

const CardMenu = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        backgroundImage: `url('bg3.svg')`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        py: { xs: 6, md: 10 },
      }}
    >
      <Box
        sx={{
          px: { xs: 2, sm: 4, md: 8, lg: 12 },
          width: { xl: "74%", lg: "79%", md: "90%", sm: "90%", xs: "100%" },
        }}
      >
        <Grid container spacing={{ xs: 3, md: 4 }} justifyContent="center">
          {cardData.map((card, index) => (
            <Grid item xs={12} sm={card.gridSize} key={index}>
              <Card
                sx={{
                  bgcolor: backgroundColors[index % backgroundColors.length],
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  height: '100%',
                  boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                  borderRadius: 2,
                  cursor: "pointer",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                    transform: "translateY(-4px)",
                  },
                }}
              >
                <CardMedia
                  component="img"
                  image={card.image}
                  alt={card.title}
                  sx={{
                    objectFit: "contain",
                    width: "100%",
                    maxHeight: { xs: 200, sm: 250, md: 300 },
                    px: { xs: 2, sm: 3, md: 4 },
                    WebkitMaskImage: "linear-gradient(black, transparent)",
                    maskImage: 'linear-gradient(to bottom, black 70%, rgba(0, 0, 0, 0.3) 80%, transparent 100%)',
                  }}
                />
                <CardContent
                  sx={{
                    px: { xs: 2, sm: 3, md: 4 },
                    textAlign: "left",
                  }}
                >
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    gutterBottom
                    sx={{
                      fontSize: { xs: "1.1rem", sm: "1.4rem", md: "1.5rem" },
                    }}
                  >
                    {card.title}
                  </Typography>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{
                      fontSize: { xs: "0.9rem", sm: "1rem", md: "1.05rem" },
                      mb: 2,
                    }}
                  >
                    {card.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default CardMenu;
